module.exports = __webpack_public_path__ + "static/media/vinfast.bca80283.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/TestimonialsCarousel/assets/partner/vinfast.png
// module id = 1103
// module chunks = 0